import {FC} from 'react'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {TabModel} from '../../../../../../models'
import ButtonClose from '../../../../../../components/UI/Button/IconButton'
import {TableGuestBookingListWrapper} from '../Tables/TableGuestBookingList'

const DetailGuestListPanel: FC = () => {
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useHoteleria()
  const handleBack = () => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
    }
    changeCurrentTabItem(obj)
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <>
      <div className='sdx_content_tab_panel'>
        {isDisabled && <ButtonClose onClick={handleBack} color='#283897' />}
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            {isAllowed('RESERVASXHUESPED/ACCESO') && (
              <Tab className={'sdx_sub_tab_panel_option'}>Reservas por Huésped</Tab>
            )}
          </TabList>
          {isAllowed('RESERVASXHUESPED/ACCESO') && (
            <TabPanel>
              <TableGuestBookingListWrapper />
            </TabPanel>
          )}
        </Tabs>
      </div>
    </>
  )
}

export {DetailGuestListPanel}
